"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.confirmed.title': 'Płatność Pomyślna!',
    'payment.confirmed.message': 'Dziękujemy za płatność. Twoja transakcja została pomyślnie zakończona.',
    'payment.confirmed.details': 'Szczegóły Płatności',
    'payment.confirmed.date': 'Data Płatności',
    'payment.confirmed.paymentIntent': 'ID Intencji Płatności',
    'payment.confirmed.fetchError': 'Nie można pobrać szczegółów płatności',
    'payment.confirmed.unknownProvider': 'Nieznany Dostawca',
    'payment.confirmed.accountUpgraded': 'Konto Pomyślnie Uaktualnione',
    'payment.confirmed.accountUpgradedMessage': 'Twoje konto zostało uaktualnione i nowe funkcje są teraz dostępne.',
    'payment.confirmed.nextSteps': 'Co Dalej?',
    'payment.confirmed.nextStepsMessage': 'Możesz teraz zacząć korzystać z ulepszonych funkcji. Odkryj czat AI, twórz awatary i zarządzaj swoją bazą wiedzy.',
    'payment.confirmed.startChatting': 'Rozpocznij Czat',
    'payment.confirmed.viewAccount': 'Zobacz Konto',
    'payment.confirmed.backHome': 'Powrót do Strony Głównej',
    'payment.confirmed.receiptInfo': 'Potwierdzenie zostało wysłane na Twój adres email. Możesz też pobrać je z ustawień konta.',
};
